<template>
	<div id="top" class="container" :class="{ 'no-heading-image': !page.headingImage, subpage: page.slug !== 'index' }">
		<Html :lang="locale" />
		<Head v-if="page">
			<Title>{{ page.metaTitle }}</Title>
			<Meta name="description" :content="page.metaDescription" />
			<Meta name="robots" :content="page.metaRobots" />
			<Hreflangs v-if="page.slug !== '404'" :langmenu="page.langmenu" />
		</Head>

		<navigation />

		<slot />

		<breadcrumbs
			v-if="page && page.slug != 'index'"
			:breadcrumbs="page.breadcrumbs"
			:home="defaults[locale].website.hotelName"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content ?? ''"
			:button="defaults[locale].newsletter.button"
		/>
		<footers />

		<pop-up
			v-if="page && defaults[locale].popUp.content"
			:image="defaults[locale].popUp.image"
			:content="defaults[locale].popUp.content ?? ''"
		/>
		<cookie-consent
			v-if="page && defaults[locale].cookieConsent.content"
			:content="defaults[locale].cookieConsent.content ?? ''"
			:position="defaults[locale].cookieConsent.position"
		/>
		<to-top />
	</div>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const config = useRuntimeConfig();
const route = useRoute();
const { defaults, fetchDefaults } = useDefaults();

if (!defaults.value) {
	await fetchDefaults();
}

await fetchPage();

const handleScroll = () => {
	const fixedElements = document.querySelectorAll('.fix-on-scroll');
	if (window.scrollY >= 50) {
		fixedElements.forEach((el) => el.classList.add('fixed'));
	} else {
		fixedElements.forEach((el) => el.classList.remove('fixed'));
	}
};

onMounted(() => {
	window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
	window.removeEventListener('scroll', handleScroll);
});

const currentUrl = config.public.siteUrl + route.fullPath;
const { website } = defaults.value[locale.value];
const { metaDescription, metaTitle } = page.value;

if (import.meta.server) {
	useSeoMeta({
		twitterCard: metaDescription || '',
		twitterSite: currentUrl || '',
		twitterTitle: metaTitle || '',
		twitterDescription: metaDescription || '',
		twitterCreator: website.hotelName || '',
		twitterImage: website.structuredImage || '',
		ogTitle: metaTitle || '',
		ogUrl: currentUrl || '',
		ogImage: website.structuredImage || '',
		ogDescription: metaDescription || '',
		ogSiteName: website.hotelName || '',
	});

	useHead({
		script: [
			{
				type: 'application/ld+json',
				innerHTML: JSON.stringify({
					'@context': 'http://schema.org',
					'@graph': [
						{
							'@type': 'Hotel',
							'@id': `${config.public.siteUrl}#hotel`,
							image: website.structuredImage,
							url: config.public.siteUrl,
							name: website.hotelName,
							logo: `${config.public.siteUrl}/images/logo-villaschoolthoff-full-black.png`,
							telephone: website.phone,
							email: website.email,
							address: {
								'@type': 'PostalAddress',
								streetAddress: `${website.street} ${website.number}, ${website.city}`,
								postalCode: website.postalCode,
							},
						},
					],
				}),
			},
		],
	});
}
</script>
